/**
 * Check input errors
 * @param {Object} error
 * @return {String}
*/
const errorHandler = (error) => {
  if (error && error.status >= 400 && error.status < 500) {
    if (error.status === 409) {
      return 'emailAlreadyExist';
    } else if (error.extraData) {
      let errors = error.extraData.errors;

      if (errors && errors.email) {
        return 'invalidEmail';
      } else if (errors && errors.password) {
        return 'password';
      }
      return 'apiError';
    }
  }
  return 'apiError';
};

export default errorHandler;